import React from 'react';

/**
 * react-loadable doesn't export the props interface
 * but this is a sub-set of the one defined in that package
 */
interface LoadingPageProps {
  pastDelay?: boolean;
  isSubComponent?: boolean;
}

const LoadingPage: React.FC<LoadingPageProps> = ({
  pastDelay,
  isSubComponent
}) => {
  if (pastDelay) {
    return (
      <div
        style={{
          width: isSubComponent ? '100%' : '100vw',
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <div
          style={{
            margin: 'auto',
            width: '100%',
            textAlign: 'center'
          }}
        >
          <img
            src="/static/images/caresignal-logo-v2.png"
            className="sharp-image breathing-effect"
            alt="CareSignal Logo"
            style={{
              maxWidth: '300px'
            }}
          />
          <div
            style={{
              width: '100%',
              textAlign: 'center'
            }}
          >
            Almost there...
          </div>
        </div>
      </div>
    );
  }
  return null;
};

export default LoadingPage;
